import { render, staticRenderFns } from "./EcommerceTransactions.vue?vue&type=template&id=9a7ff93e&"
import script from "./EcommerceTransactions.vue?vue&type=script&lang=js&"
export * from "./EcommerceTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a7ff93e')) {
      api.createRecord('9a7ff93e', component.options)
    } else {
      api.reload('9a7ff93e', component.options)
    }
    module.hot.accept("./EcommerceTransactions.vue?vue&type=template&id=9a7ff93e&", function () {
      api.rerender('9a7ff93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceTransactions.vue"
export default component.exports